import React from "react";
import Footer from "../components/common/Footer";
import NavBar from "../components/common/NavBar";
import TopImage from "../components/common/TopImage";

function RulesList({ title, rules }) {
  return (
    <div className="mb-6">
      <span className="text-3xl font-bold">{title}</span>
      <ul className="list-disc pl-6 mt-2 text-gray-700">
        {rules.map((rule, index) => (
          <li key={index} className="mb-2">
            {rule}
          </li>
        ))}
      </ul>
    </div>
  );
}

const RulesPage = (props) => {
  const dos = [
    "Students must attend all classes regularly and punctually unless excused for valid reasons.",
    "Students to arrive in the school on time. No entry is allowed for the late comers. They must wear neat, ironed and proper sized uniform with a proper hair cut & nails trimmed.",
    "Students to carry their Identity Card (with the latest photograph in school uniform) and school diary every day, failing which they will not be allowed to enter the class, laboratory, library or school assembly and functions.",
    "At the sound of the first bell, students should assemble for prayer; after the assembly is over they have to move quietly in a line to their respective classrooms.",
    "Students should keep their classrooms and school premises clean and tidy.",
    "During school hours, students should move about in silence and in order.",
    "Attendants bringing the Tiffins should wait near the school gate till the bell for interval rings and then the students to go and bring their Tiffins.",
    "Every student must take part in school games and other activities unless declared physically unfit or exempted by the Principal.",
    "Students being dropped and picked up by the parents must leave with them only. In case of delay, they should report to the security officer at the main gate.",
    "Students should behave in a proper manner wherever they go, they should remember that the school is judged by their conduct. They should greet their seniors, teachers and elders whenever & wherever they meet them.",
    "Once a student has been selected for any programme, he has to compulsorily attend the same. No relaxation will be given.",
  ];

  const donts = [
    "Students are not allowed to bring to school or keep costly items or any kind of valuables like calculators, precious coins, stamps, items of jewellery etc. The school will not be responsible for the loss of any such article, although proper care is taken to prevent such happenings.",
    "Students are not allowed to use the school telephone without permission. To use the telephone, they should obtain prior permission of the receptionist. They will not be allowed to answer a phone call during school hours.",
    "No collection for any purpose whatsoever shall be made in the school without the prior permission of the Principal.",
    "No student should scratch or spoil the desks or damage any school property, write or draw anything on the wall/furniture or in any way damage things belonging to others. Damage done even by accident should be reported at once to the class teacher or the Principal. Any damage done will be made good by the concerned student (s) together with a fine imposed on him/them for such an offence. Such offence may entail expulsion from the school also.",
    "Students are not allowed to wear any rings, bracelets, ear rings or any other items of jewellery in the school.",
    "Mobile phones, CD's, pen drives, cameras, IPods etc. are strictly prohibited in the school premises. Students of classes I to VIII are not allowed to wear wrist watches.",
  ];

  const strictActions = [
    "he deviates from the school norms & guidelines.",
    "he damages/spoils the school property, furniture, walls etc.",
    "he is indisciplined & does not improve after repeated warnings and there is sufficient evidence/report against him.",
    "his conduct is undesirable and is harmful to school. Immorality, grave insubordination, contempt for authority or willful damage to school property are sufficient reasons for immediate expulsion from school.",
    "he brings fires crackers in the school premises.",
    "he brings/splashes colours in the school premises.",
    "he wears any rings, bracelets, ear rings or any other items of jewellery in the school.",
    "he brings mobile phones, CD's, cameras, IPods or any other objectionable material in the school premises.",
    "he does not come to school properly dressed along with proper hair cut and trimmed nails after repeated warnings.",
    "he does not bring his diary & I-Card regularly and has been warned repeatedly.",
  ];

  return (
    <div>
      <NavBar />
      <TopImage text="Rules And Regulations"/>

      <div className="mx-28 mt-20 max-md:mx-5 max-md:mt-8 text-base tracking-wide capitalize text-zinc-800  ">
        <RulesList title="Do's" rules={dos} />
        <RulesList title="Don'ts" rules={donts} />
        <span className="text-3xl font-bold">The school may take strict action against a student if:</span>
        <ul className="list-disc pl-6 mt-2 text-gray-700">
          {strictActions.map((action, index) => (
            <li key={index} className="mb-2">
              {action}
            </li>
          ))}
        </ul>
      </div>
      <div className="mx-48 my-20 max-md:mx-8 max-md:my-8 text-2xl font-bold tracking-wide text-red-700 text-justify capitalize">
      Students who violate school rules may face disciplinary action, which
      could include warnings, detention, suspension, or expulsion, depending on
      the severity of the offense and school policies.
    </div>
      <Footer />
    </div>
  );
};

export default RulesPage;
